import React from "react";
import {
  Edit,
  SimpleFormIterator,
  ArrayInput,
  BooleanInput,
  TextInput,
  NumberInput,
  SelectInput,
  Toolbar,
  FormDataConsumer,
  SimpleForm,
  required,
  choices,
  number,
  minValue,
  maxValue,
} from "react-admin";
import CancelButton from "../common/CancelButton";
import SaveButton from "../common/SaveButton";

const styles = {
  numberLabel: { width: "16.5em" },
  boolLabel: { width: "18em" },
};

const EditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
    <CancelButton />
  </Toolbar>
);

const bytes = (str) => {
  str = str == null ? "" : str;
  return encodeURI(str).replace(/%../g, "x").length;
};

const validatemaxBytes = (value, allValues, props) => {
  if (bytes(value) > 100) {
    return props.translate("ra.validation.tooLong");
  }
};

const validateInteger = (value, allValues, props) => {
  if (!Number.isInteger(value)) {
    return props.translate("ra.validation.integer");
  }
};

const validateName = [required(), validatemaxBytes];
const validateCheckinMode = [required(), choices([0, 1])];
const validateCancelTimeout = [
  required(),
  number(),
  minValue(1),
  maxValue(60),
  validateInteger,
];
const validateReminderTime = [
  required(),
  number(),
  minValue(1),
  maxValue(60),
  validateInteger,
];
const validateReminderTimeUnit = [
  required(),
  choices(["day", "hour", "minute"]),
];
const validatePeriod = [
  required(),
  number(),
  minValue(1),
  maxValue(480),
  validateInteger,
];

const RuleEdit = (props) => (
  <Edit {...props}>
    <SimpleForm toolbar={<EditToolbar />} submitOnEnter={false}>
      <TextInput source="name" validate={validateName} />
      <SelectInput
        source="checkinMode"
        validate={validateCheckinMode}
        choices={[
          { id: 0, name: "resources.operation-rules.enums.checkinMode.button" },
          { id: 1, name: "resources.operation-rules.enums.checkinMode.code" },
        ]}
      />
      <BooleanInput source="isCancelEnabled" style={styles.boolLabel} />
      <FormDataConsumer>
        {({ formData, ...rest }) =>
          formData.isCancelEnabled && (
            <NumberInput
              source="cancelTimeout"
              label="resources.operation-rules.fields.cancelTimeout"
              validate={validateCancelTimeout}
              style={styles.numberLabel}
            />
          )
        }
      </FormDataConsumer>
      <ArrayInput source="reminderTimings">
        <SimpleFormIterator>
          <NumberInput
            source="time"
            label="resources.operation-rules.fields.timing"
            validate={validateReminderTime}
          />
          <SelectInput
            source="unit"
            label="resources.operation-rules.fields.timeUnit"
            validate={validateReminderTimeUnit}
            choices={[
              {
                id: "day",
                name: "resources.operation-rules.enums.reminderTimeUnit.day",
              },
              {
                id: "hour",
                name: "resources.operation-rules.enums.reminderTimeUnit.hour",
              },
              {
                id: "minute",
                name: "resources.operation-rules.enums.reminderTimeUnit.minute",
              },
            ]}
          />
        </SimpleFormIterator>
      </ArrayInput>
      <BooleanInput source="isImmediateUseEnabled" style={styles.boolLabel} />
      <FormDataConsumer>
        {({ formData, ...rest }) =>
          formData.isImmediateUseEnabled && (
            <NumberInput
              source="immediateUsePeriod"
              label="resources.operation-rules.fields.immediateUsePeriod"
              validate={validatePeriod}
              style={styles.numberLabel}
            />
          )
        }
      </FormDataConsumer>
      <BooleanInput source="isExtendEnabled" style={styles.boolLabel} />
      <FormDataConsumer>
        {({ formData, ...rest }) =>
          formData.isExtendEnabled && (
            <NumberInput
              source="extendPeriod"
              label="resources.operation-rules.fields.extendPeriod"
              validate={validatePeriod}
              style={styles.numberLabel}
            />
          )
        }
      </FormDataConsumer>
      <BooleanInput source="isUserCountEnabled" style={styles.boolLabel} />
      <BooleanInput source="isIncognito" style={styles.boolLabel} />
    </SimpleForm>
  </Edit>
);

export default RuleEdit;
